import { Controller } from "@hotwired/stimulus";
import { XhrResponse } from "../helpers/xhr";
import { templatizeHtml } from "../helpers/dom";

export default class ApplicationController<T extends Element = HTMLElement> extends Controller<T> {
  // TODO: this is no longer needed once we rely on XhrController for all Xhr requests
  dispatchXhrResponse(xhrResponse: XhrResponse) {
    const { html } = xhrResponse;
    const template = templatizeHtml(html!);
    template.content.querySelectorAll<HTMLTemplateElement>("template[data-event]").forEach((child) => {
      const { event } = child.dataset;
      this.dispatch(event!, { prefix: "", bubbles: true, detail: { html: child.innerHTML, data: child.dataset } });
    });
    return xhrResponse;
  }
}
